/* eslint-disable quotes */
import http from '@/util/http'

// 查询所有菜单
export function allMenus () {
  return http({
    url: '/api/systemPower/queryAll',
    method: 'get'
  })
}

//
export function edit (data) {
  return http({
    url: '/api/systemLogisticsExpress/updateInterfaceParameters',
    method: 'post',
    data
  })
}

export function deletGroupInfo (orgId) {
  return http({
    url: `/api/comOrganization/updateFlagById/${orgId}`,
    method: 'post'
  })
}

/**
 * 添加角色
 * @param {*} data
 */
export function addroleInfo (data) {
  return http({
    url: '/api/role/add',
    method: 'post',
    data
  })
}

export function addRolePower (id, data) {
  return http({
    url: `/api/role/addPower/${id}`,
    method: 'post',
    data
  })
}

/**
 * 删除当前角色
 * /api/role/removeRole/{user_id}/{role_id}
 */
export function deletRoleInfo (id) {
  return http({
    url: `/api/role/updateByFlag/${id}`,
    method: 'post'
  })
}

/**
 * 文件模版接口数据
 * @param {*} data
 */
export const FileTemplate = {
  getTemplateInfo: (title) => {
    return http({
      url: `/api/systemFileTemplate/queryTemplateWildcard/${title}`,
      method: 'post'
    })
  },

  FileTemUpdate: () => {
    return http({
      url: '/api/systemFileTemplate/updateByFileTemplate',
      mthod: 'post'
    })
  },
  getTempFIleList: () => {
    return http({
      url: '/api/systemFileTemplate/queryTemplateWildcard',
      method: 'post'
    })
  },
  updateInfo: (data) => {
    return http({
      url: '/api/systemFileTemplate/updateByFileTemplate',
      method: 'post',
      data

    })
  },
  handleAll: () => {
    return http({
      url: '/api/systemFileTemplate/queryAllTemplate',
      method: 'post'
    })
  }
}

// 查看第对应的操作权限是否选中
export const getInfoCheckstatus = (roleId, powerId) => {
  return http({
    url: `/api/systemPower/queryAllByMenuId/${roleId}/${powerId}`,
    method: 'get'
  })
}

// 添加权限菜单
export const addresour = (roleId, data) => {
  return http({
    url: `/api/role/addPower/${roleId}`,
    method: 'post',
    data
  })
}

/**
 *
 *
 * @export
 * @return {*}
 */
export function getRoleListAll () {
  return http({
    url: 'api/role/queryPageAll/1/100000?key=',
    method: 'get'
  })
}

/**
 *获取具体的角色信息
 *
 */
export function getgroupItem (id) {
  return http({
    url: `/api/systemPower/queryAllByMenuId?key=${id}`,
    method: 'get'
  })
}

/***
 * 配置自己的express 服务开启模式
 * 前缀是http://localhost:8080/api/
 *
 */
export function getRoledeailInfoItems (id) {
  return http({
    url: `http://localhost:8080/api/getRole/${id}`,
    method: 'get'
  })
}

/**
 *
 *根绝角色ID来查询当前的权限操作
 * @export
 * @param {*} data
 * @return {*}
 * /api/role/queryPowerByRoleId/{role_id}
 */

export function getRoleInfodetail (uid) {
  return http({
    url: `/api/role/queryPowerByRoleId/${uid}`,
    method: 'get'
  })
}

export function getRoleDetail () {
  return http({
    url: '/api/systemPower/queryPowerAll',
    method: 'get'
  })
}

export function getRolePermission () {
  return http({
    url: '/api/systemPower/queryGetPowerAndChildAll',
    method: 'get'
  })
}

export function loadchilddata (data) {
  return http({
    url: `/api/systemPower/queryPostPowerById/${data.id}`,
    method: 'get'
  })
}

export function getroleInfo (data) {
  return http({
    url: '/api/role/queryStaffBySrId',
    method: 'post',
    data
  })
}

/**
 * 设置负责人
 * @param {*} page
 * @param {*} size
 */
export function addGroupPerson (data) {
  return http({
    url: '/api/brandBase/updateBrandPersonCharge',
    method: 'post',
    data
  })
}

/**
 * 账号管理
 * @param {*} data
 * 所有的角色信息
 */
export function getRoleList (page, size) {
  return http({
    url: `/api/role/queryPageAll/${page}/${size}`,
    method: 'get'
  })
}

export function getPowerByRoleId (data) {
  return http({
    url: `/api/role/queryPowerByRoleId/${data.roId}`,
    method: 'post'
  })
}

/*
* 获取所有员工
* */
export function getAllStaff (data = { page: 1, size: 300 }) {
  return http({
    url: `/api/staffBase/querySystemStaffBase/${data.page}/${data.size}`,
    method: 'post',
    data: {
      criteriaVoList: [
        {
          collection: true,
          column: "",
          endValue: "",
          expression: "",
          value: "",
          valueType: ""
        }
      ],
      queryPageName: ""
    }
  })
}

export function getOnegroup (orgId) {
  return http({
    url: `/api/comOrganization/queryById/${orgId}`,
    method: 'get'
  })
}

export function updateUserInfo (data) {
  return http({
    url: '/api/staffBase/edit',
    method: 'post',
    data
  })
}

export function getUserInfo (id, cancale) {
  return http({
    url: `/api/staffBase/queryById/${id}`,
    method: 'get',
    cancale
  })
}

// eslint-disable-next-line no-multi-spaces
export function BanKHeader () {
  return http({
    url: "/api/systemBankHeader/queryAllBankHeader",
    method: "post"
  })
}

export function AddBankHeader (data) {
  return http({
    url: "/api/systemBankHeader/updateBankHeader",
    method: "post",
    data
  })
}

export function imporystorageAll (orgId) {
  return http({
    url: `/api/comOrganization/queryAllByStorageBase/${orgId}`,
    method: 'get'
  })
}

export function editGroupRole (data) {
  return http({
    url: '/api/role/addByComOrganization',
    method: 'post',
    data
  })
}

export function getAddgroupItem (data) {
  return http({
    url: '/api/comOrganization/add',
    method: 'post',
    data
  })
}

export function updategroupname (data) {
  return http({
    url: '/api/comOrganization/update',
    method: 'post',
    data
  })
}

/**
 * 获取系统组织树结构的方式
 * @param {*} id
 * @param {*} state
 *
 */
export function getTreegroup () {
  return http({
    url: '/api/comOrganization/queryAll',
    method: 'get'
  })
}

export function updataStore () {
  return http({
    url: "/api/comOrganization/updateStorage",
    method: 'get'
  })
}
/*
* 组织架构新增角色
* */
export function treeAddRole (data) {
  return http({
    url: '/api/role/addRole',
    method: 'post',
    data
  })
}

/*
* 查询组织架构节点的子节点
* */
export function getCurNodeChild (data) {
  return http({
    url: `/api/comOrganization/queryComOrganizationRoleByOrgId/${data.orgId}`,
    method: 'get'
  })
}

/**
 * 当前用户状态
 */
export function updataStatus (id, state) {
  return http({
    url: `/api/staffBase/editSystemState/${id}/${state}`,
    method: 'post'
  })
}

/**
 * 获取所有的员工部门
 * @param {*} data
 */
export function getgroupList () {
  return http({
    url: '/api/staffBase/queryRoleAndComAuthorization',
    method: 'get'
  })
}

export function getGrouSum (page, size, data) {
  return http({
    url: `/api/staffBase/querySystemStaffBase/${page}/${size}`,
    method: 'post',
    data
  })
}

export function addPingpai (data) {
  return http({
    url: '/api/brandBase/add',
    method: 'post',
    data
  })
}

export const getGrouoRole = (coId) => {
  return http({
    url: `/api/role/queryRoleByCoId/${coId}`,
    method: 'get'
  })
}

/**
 * 公司信息修改
 * @param {*} data
 */
export function company (data) {
  return http({
    url: '/api/comInformation/update',
    method: 'post',
    data
  })
}

export const getCompany = () => {
  return http({
    url: '/api/comInformation/findBySystem',
    method: 'post'
  })
}

export function expressSort (data) {
  return http({
    url: "/api/systemLogisticsExpress/updateSort",
    method: 'post',
    data
  })
}

export function orderTaxRateSort (data) {
  return http({
    url: '/api/financeBillTaxSetting/updateSort',
    method: 'post',
    data
  })
}

/**
 * 其他票据税率设置
 */
export function addTaxRate (data) {
  return http({
    url: '/api/financeBillTaxSetting/addFinanceBillTaxSetting',
    method: 'post',
    data
  })
}

export function gettaxRate (page, size) {
  return http({
    url: `/api/financeBillTaxSetting/queryFinanceBillTaxSetting/${page}/${size}`,
    method: 'get'
  })
}

export function getBankSort (data) {
  return http({
    url: "/api/financeBankInfo/updateSort",
    method: 'post',
    data
  })
}

/**
 *
 * =企业银行账号
 *
 *
 * @param {*} data
 */
export const getEnterpriseList = (page, size) => {
  return http({
    url: `/api/financeBankInfo/queryFinanceBankInfo/${page}/${size}`,
    method: 'get'
  })
}
export const addEnterPrise = (data) => {
  return http({
    url: '/api/financeBankInfo/addFinanceBankInfo',
    method: 'post',
    data
  })
}
export const updateEnterPrise = (data) => {
  return http({
    url: '/api/financeBankInfo/updateFinanceBankInfo',
    method: 'post',
    data
  })
}
export const getsafe = () => {
  return http({
    url: '/api/systemFlowForm/queryAll',
    method: 'get'

  })
}

// ?
export const isEnableEnterPrise = (fbiId, flag) => {
  return http({
    url: `/api/financeBankInfo/updateFinanceBankInfoByFlag/${fbiId}/${flag}`,
    method: 'post'
  })
}
export const UpdatetaxRate = (data) => {
  return http({
    url: '/api/financeBillTaxSetting/updateFinanceBillTaxSetting',
    method: 'post',
    data
  })
}

// 其他税率启用
export function isEnable (ftsId, flag) {
  return http({
    url: `/api/financeBillTaxSetting/updateFinanceBillTaxSettingFlag/${ftsId}/${flag}`,
    method: 'post'
  })
}

/**
 * 系统罚没
 *
 */
export const getConfiascateRation = () => {
  return http({
    url: '/api/financeBillTaxSetting/queryConfiscateRatio',
    method: 'get'
  })
}
export const updateConfiscateRation = (data) => {
  return http({
    url: '/api/financeBillTaxSetting/updateConfiscateRatio',
    method: 'post',
    data
  })
}

//  -----

/**
 *
 * @param {
 * } data
 *
 */
export function CommissionList () {
  return http({
    url: '/api/systemCommissionSetting/querySystemCommissionSetting',
    method: 'get'
  })
}

export const AddCommissInfo = (data) => {
  return http({
    url: '/api/systemCommissionSetting/addSystemCommissionSetting',
    method: 'post',
    data
  })
}
export const AddSalire = (ids, serial) => {
  return http({
    url: `/api/systemCommissionSetting/addSerial/${ids}/${serial}`,
    method: 'post'
  })
}
export const delteCommissInfo = (scsId) => {
  return http({
    url: `/api/systemCommissionSetting/deleteSystemCommissionSetting/${scsId}`,
    method: 'post'

  })
}

/**
 * 系统设置品牌管理
 * @param {*} data
 */
export const getBrandList = (page) => {
  return http({
    url: `/api/brandBase/queryBrandList`,
    method: 'post'
  })
}
// 保存设置品牌负责人
export const saveBrandLeader = (data) => {
  return http({
    url: `/api/brandBase/updateBrandLeader`,
    method: 'post',
    data
  })
}
export const UpdateComminsIfo = (data) => {
  return http({
    url: '/api/systemCommissionSetting/updateSystemCommissionSetting',
    method: 'post',
    data
  })
}

/**
 *期货的处理模块
 * @param {*} data
 */

// 期货的删除和新增
export function deleteItem (sasId) {
  return http({
    url: `/api/systemDeliverySetting/deleteSystemDelivery/${sasId}`,
    method: 'post'
  })
}

export function updatesystem (data) {
  return http({
    url: '/api/systemDeliverySetting/addSystemUpdate',
    method: 'post',
    data
  })
}

export function updataTixingSystem (data) {
  return http({
    url: '/api/systemDeliverySetting/updateSystemDeliveryPlatForm',
    method: 'post',
    data
  })
}

// 货期与提醒设置
export const getDeliveryperoidAdd = (data) => {
  return http({
    url: '/api/systemDeliverySetting/updateSystemDeliveryPlatForm',
    method: 'post',
    data
  })
}

export function addAllpervodid (data) {
  return http({
    url: '/api/systemDeliverySetting/addSystemDeliveryPlatForm',
    method: 'post',
    data
  })
}

// 货期与提醒获取列表数据
export function getAllpervodidlist () {
  return http({
    url: '/api/systemDeliverySetting/querySystemDeliveryPlatForm',
    method: 'get'
  })
}

export function editstatus (sleId) {
  return http({
    url: `/api/systemLogisticsExpress/updateInterfaceSwitch/${sleId}`,
    method: 'post'
  })
}

// 系统设置物流信息接口
export function queryExpressLoginitics (page, size, data) {
  return http({
    url: `/api/systemLogisticsExpress/querySystemLogistics/${page}/${size}`,
    method: 'post',
    data
  })
}

// 查询当前登录用户的权限菜单
export function byLoginUser () {
  return http({
    url: '/api/systemPower/queryPowerMenuByLoginUser',
    method: 'get'
  })
}

// 根据多个分类类型显示属性内容
export function queryByClassCode (data) {
  return http({
    url: '/api/attrContent/queryByClassCode',
    method: 'post',
    data: data
  })
}

// 添加属性内容
export function attrContentAdd (classCode, data) {
  return http({
    url: `/api/attrContent/add/${classCode}`,
    method: 'post',
    data: data
  })
}

// 编辑预设选项
export function attrContentUpdate (data) {
  return http({
    url: '/api/attrContent/update',
    method: 'post',
    data: data
  })
}

// 启用禁用类型
export function updateStateById (id, data) {
  return http({
    url: `/api/attrContent/updateStateById/${id}`,
    method: 'get',
    params: {
      flag: data
    }
  })
}

// 根据pid查看对应下属地区
export function getQueryAddress (pId) {
  return http({
    url: `/api/systemRegion/query/${pId}`,
    method: 'post'
  })
}

// 查询所有拥有销售权限员工信息
export function queryAllHasSalePowerStaffInfo (data) {
  return http({
    url: '/api/staffBase/queryAllStaff',
    method: 'post',
    data: data
  })
}

export function queryAllAccount () {
  return http({
    url: '/api/staffBase/queryAll',
    method: 'get'
  })
}

// 拖拽更改排序
export function updateByAttId (data) {
  return http({
    url: '/api/attrContent/updateByAttId',
    method: 'post',
    data: data
  })
}

// 计量单位列表
export function queryByClassType (page, size) {
  return http({
    url: `/api/attrContent/queryByClassType/${page}/${size}`,
    method: 'post'
  })
}

// 计量单位列表
export function queryPageByClassType (classCode, page, size, data) {
  return http({
    url: `/api/attrContent/queryPageByClassType/${classCode}/${page}/${size}`,
    method: 'post',
    data: data
  })
}

// 查看系统日志列表
export function queryPageAllOperation (page, size, type) {
  return http({
    url: `/api/systemLogOperation/queryPageAll/${page}/${size}/${type}`,
    method: 'get'
  })
}

// 操作日志带
export function queryPageAllBySuaId (type, id, page, size) {
  return http({
    url: `/api/systemLogOperation/queryPageAll/${type}/${id}/${page}/${size}`,
    method: 'get'
  })
}

export function getAllRole (data) {
  return http({
    url: `/api/role/queryPageAll/${data.page}/${data.size}`,
    method: 'get'
  })
}

export function getAllAccount (data) {
  return http({
    url: `/api/staffBase/querySystemStaffBase/${data.page}/${data.size}`,
    method: 'post',
    data: {
      criteriaVoList: [{
        collection: true,
        column: "",
        endValue: "",
        expression: "",
        value: "",
        valueType: ""
      }],
      queryPageName: ""
    }
  })
}

export function brandBaseAdd () {
}

export function brandBaseUpdateById () {
}

export function updateDefinition (data) {
  return http({
    url: '/api/systemFlowDefinitionNode/updateDefinition',
    method: 'post',
    data
  })
}
export function queryFlowDefinitionNodeByFlowId (flowId) {
  return http({
    url: `/api/systemFlowDefinitionNode/queryFlowDefinitionNodeByFlowId/${flowId}`,
    method: 'get'
  })
}

export function queryPostPowerByFatherIds (data) {
  return http({
    url: '/api/systemPower/queryPostPowerByFatherIds',
    method: 'post',
    data
  })
}

export function updateOccupancyRatio (occupancyRatio) {
  return http({
    url: '/api/financeSetting/updateOccupancyRatio',
    method: 'post',
    params: {
      occupancyRatio
    }
  })
}

export function queryFinanceSetting () {
  return http({
    url: '/api/financeSetting/queryFinanceSetting',
    method: 'post'
  })
}
// 下拉框和提示通用接口格式
export function selectHttp (url, data) {
  return http({
    url: url,
    method: 'post',
    data: data
  })
}
// export function brandBaseAdd(){}
// export function brandBaseAdd(){}
